import { css } from '@emotion/react';
import { getScreen } from '@/styles/media-query';

export type CollaboratorCardProps = {
  className?: string;
  index: number;
  head: React.ReactNode;
  comment: React.ReactNode;
  subText: React.ReactNode;
  spImage: React.ImgHTMLAttributes<HTMLImageElement>;
  pcImage: React.ImgHTMLAttributes<HTMLImageElement>;
};

export const CollaboratorCard: React.FC<CollaboratorCardProps> = ({
  className,
  index,
  name,
  subText,
  comment,
  spImage,
  pcImage,
}) => {
  return (
    <div
      css={css`
        position: relative;
        z-index: 1;

        @media ${getScreen('pc')} {
          max-width: 1080px;
          width: 100%;
        }
      `}
      className={className}
    >
      <div
        css={css`
          position: relative;
          background: #ffffff;
          box-shadow: 0px 0px 36px rgba(0, 0, 0, 0.04);
          border-radius: 32px;
          min-height: 250px;
          padding: 0px;

          @media ${getScreen('pc')} {
            padding: 20px 25px;
          }
          
          &::before {
            content: '';
            position: absolute;
            left: 0px;
            bottom: 0;
            z-index: 4;
            display: block;
            height: 100%;
            width: 236px;
            border-radius: 32px 0 0 32px;
            background: linear-gradient(288deg, rgba(241,255,253,0) 0%, rgba(241,255,253,0) 26%, rgba(113,217,210,0.39) 26%, rgba(113,217,210,0.39) 100%);

            @media ${getScreen('pc', '未満')} {
              display: none;
            }
          }
          
          
        `}
      >
        <dl
          css={css`
            position: relative;
            z-index: 5;
          `}
        >
          <dt
            css={css`
              position: relative;
              margin-bottom: 20px;
              
              @media ${getScreen('pc', '未満')} {
                padding: 5px 20px 0 0px;
                border-bottom: 1px solid #D1D8DD;
                margin-bottom: 20px;
              }
              
              &::before {
                content: '';
                position: absolute;
                left: 0px;
                bottom: 0;
                z-index: 4;
                display: block;
                height: 100%;
                width: 133px;
                border-radius: 32px 0 0 0;
                background: linear-gradient(288deg, rgba(241,255,253,0) 0%, rgba(241,255,253,0) 26%, rgba(113,217,210,0.39) 26%, rgba(113,217,210,0.39) 100%);

              }
              
            `}
          >
            <figure
              css={css`
                @media ${getScreen('pc', '未満')} {
                  position: relative;
                  z-index: 5;
                  display: flex;
                  align-items: center;
                }
              `}
            >
              <div
                css={css`
                  flex-shrink: 0;
                  
                  @media ${getScreen('pc')} {
                    position: absolute;
                    left: 0;
                    z-index: 5;
                    width: 270px;
                    
                  }
                  @media ${getScreen('pc', '未満')} {
                    width: 165px;
                  }
                  
                `}
              >
                <img
                  css={css`
                    max-width: 100%;
                    height: auto;
                    clip-path: circle(55px at center);

                    @media ${getScreen('pc')} {
                      display: none;
                      
                    }
                  `}
                  {...spImage}
                  loading="lazy"
                />
                <img
                  css={css`
                    max-width: 100%;
                    height: auto;
                    border-radius: 40px;

                    @media ${getScreen('pc', '未満')} {
                      display: none;
                    }
                  `}
                  {...pcImage}
                  loading="lazy"
                />
              </div>
              <figcaption
                css={css`
                  margin-left: 0px;
                  @media ${getScreen('pc')} {
                    margin-left: 315px;
                  }
                `}
              >
                <small
                  css={css`
                    font: normal normal bold 14px/18px 'din-2014-narrow';
                    letter-spacing: 2.52px;
                    color: #00B3A7;
                    vertical-align: bottom;
                    
                    @media ${getScreen('pc')} {
                      font: normal normal bold 14px/18px 'din-2014-narrow';
                      letter-spacing: 2.52px;
                    }
                    @media ${getScreen('pc', '未満')} {
                      display: block;
                    }
                  `}
                >
                  {subText}
                </small>
                <strong
                  css={css`
                    position: relative;
                    font: normal normal bold 18px/24px 'Noto Sans JP';
                    letter-spacing: 0.72px;
                    color: #00B3A7;
                    vertical-align: bottom;
                    
                    @media ${getScreen('pc')} {
                      margin-left: 20px;
                      padding-left: 20px;
                      font: normal normal bold 24px/32px 'Noto Sans JP';
                      letter-spacing: 0.96px;
                    }
                    
                    &::before {
                      content: '';
                      position: absolute;
                      left: 0px;
                      bottom: 2px;
                      display: block;
                      height: 25px;
                      width: 1px;
                      background: #00B3A7;

                      @media ${getScreen('pc', '未満')} {
                        display: none;
                      }
                    }
                    
                  `}
                >
                  {name}
                </strong>
              </figcaption>
            </figure>
          </dt>
          <dd
            css={css`
              font: normal normal normal 14px/24px 'Noto Sans JP';
              letter-spacing: 0.28px;
              color: #444557;
              
              @media ${getScreen('pc')} {
                margin-left: 315px;
                font: normal normal normal 16px/26px 'Noto Sans JP';
                letter-spacing: 0.51px;
              }
              @media ${getScreen('pc', '未満')} {
                padding: 0 20px 15px;
              }
            `}
          >
            {comment}
          </dd>
        </dl>
      </div>
    </div>
  );
};
